import require from '@/utils/request'
import { ReqGroupPage, GroupDetailHistoryForm, GroupAddForm } from '@/types/GroupAdmin'
import qs from 'qs'

export const GroupPage = (data: ReqGroupPage) => require({
  url: '/group/queryPage',
  method: 'post',
  data
})
export const AddGroup = (data: GroupAddForm) => require({
  url: '/group/add',
  method: 'post',
  data,
  transformRequest: [
    function(data) {
      return qs.stringify(data)
    }
  ],
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const GroupDetail = (id: number) => require({
  url: 'group/detail/' + id,
  method: 'get'
})

export const GroupDetailHistory = (data:GroupDetailHistoryForm) => require({
  url: '/groupInstanceHistory/queryPage',
  method: 'post',
  data
})

export const GroupDetailExport = '/bi/groupInstanceHistory/exportInstanceHistory'
